import { L10nLocale, L10nTranslationService, L10N_LOCALE } from 'angular-l10n';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ContactsApi } from './../../hickory-api/api/contacts.service';
import { Component, OnInit, Inject } from '@angular/core';
import { BehaviorSubject, catchError, finalize, tap, throwError, defer, Observable } from 'rxjs';
import { FindContactRequest } from 'src/app/hickory-api';
import { formatDate } from '@angular/common';

@Component({
  selector: 'app-member-export-dialog',
  templateUrl: './member-export-dialog.component.html',
  styleUrls: ['./member-export-dialog.component.scss'],
  standalone: false
})
export class MemberExportDialogComponent implements OnInit {
  isDownloading$ = new BehaviorSubject<boolean>(false);
  hasError$ = new BehaviorSubject<boolean>(false);

  userType: FindContactRequest.UserTypeEnum | undefined;
  groupId: number | undefined;
  includeMemberships: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MemberExportDialogData,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    private contactsApi: ContactsApi,
    private sb: MatSnackBar,
    private translation: L10nTranslationService,
    private dialogRef: MatDialogRef<MemberExportDialogComponent>
  ) {}

  ngOnInit(): void {
    this.userType = this.data.userType;
    this.groupId = this.data.groupId;
  }

  onDownload(): void {
    this.onDownloadContacts()
      .pipe(tap(() => this.dialogRef.close()))
      .subscribe();
  }

  buildFileName(): string {
    let name = '';

    if (this.userType) {
      name += `${this.userType}-`;
    }

    if (this.groupId) {
      name += `group-${this.groupId}-`;
    }

    return `${name}member-export-${formatDate(new Date(), 'yyyy-MM-dd', 'en')}.csv`;
  }

  onDownloadContacts(): Observable<Blob> {
    return defer(() => {
      this.isDownloading$.next(true);
      this.hasError$.next(false);

      return this.contactsApi.getContactsExport(this.userType, this.groupId, this.includeMemberships).pipe(
        catchError((err) => {
          this.sb.open(this.translation.translate('Contacts.Download.Error'), 'OK', { duration: 5000 });
          this.hasError$.next(true);
          return throwError(() => err);
        }),
        tap((result) => {
          const url = URL.createObjectURL(result);
          const a = document.createElement('a');

          a.href = url;
          a.download = this.buildFileName();

          // Attach an invisible anchor to the DOM and click it to download the file
          document.body.appendChild(a);
          a.click();
          a.remove();
          URL.revokeObjectURL(url);

          this.sb.open(this.translation.translate('Contacts.Download.Success'), 'OK', { duration: 5000 });
        }),
        finalize(() => this.isDownloading$.next(false))
      );
    });
  }
}

export interface MemberExportDialogData {
  userType?: FindContactRequest.UserTypeEnum;
  groupId?: number;
}
